import React from 'react';
import { SearchIcon, CopyIcon, ShoppingBagIcon } from 'lucide-react';
export const HowItWorks = () => {
  const steps = [{
    id: 1,
    icon: <SearchIcon size={24} data-id="element-146" />,
    title: 'Find a coupon',
    description: 'Browse through our collection of deals'
  }, {
    id: 2,
    icon: <CopyIcon size={24} data-id="element-147" />,
    title: 'Copy code',
    description: 'Click to copy the discount code'
  }, {
    id: 3,
    icon: <ShoppingBagIcon size={24} data-id="element-148" />,
    title: 'Use at checkout',
    description: 'Paste the code and enjoy your savings'
  }];
  return <section className="my-12" data-id="element-149">
      <h2 className="text-lg font-bold mb-6 text-center" data-id="element-150">How It Works</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-151">
        {steps.map(step => <div key={step.id} className="flex flex-col items-center text-center" data-id="element-152">
            <div className="w-10 h-10 bg-gray-900 text-white rounded-full flex items-center justify-center mb-4" data-id="element-153">
              {step.id}
            </div>
            <h3 className="font-medium mb-1" data-id="element-154">{step.title}</h3>
            <p className="text-sm text-gray-600" data-id="element-155">{step.description}</p>
          </div>)}
      </div>
    </section>;
};